import { useCallback } from 'react';
import { useRedirectToMainApp, useServices } from '@packages/shared/core/common/hooks';

export function useCreateChat() {
  const { chatService } = useServices();
  const { redirectToExpertChat } = useRedirectToMainApp();

  const createChat = useCallback(
    async (id: string) => {
      const { chatId } = await chatService.createChat(id);

      await redirectToExpertChat(chatId);
    },
    [chatService, redirectToExpertChat],
  );

  return {
    createChat,
  };
}
